import CapsuleButton from '../../../../../../../_components/capsule-button/CapsuleButton';
import { SERVICE_OPERATION_MAXLENGTH } from '../../../../../../../constants/ServiceConstants';
import classes from './RequestResponseAttribute.module.scss';

interface IRequestResponseItems{
    item:string;
    isEditOrCreate:boolean,
    onDeleteHandler:(index:number) => void,
    index:number
}

export const RequestResponseItems = ({
    item,
    isEditOrCreate,
    onDeleteHandler,
    index
}:IRequestResponseItems) => (
  <span key={item} className={classes['encryption-label']}>
    <CapsuleButton
      label={item}
      onClickHandler={() => onDeleteHandler(index)}
      deleteIcon={isEditOrCreate}
      view={!isEditOrCreate}
      ellipseLength={SERVICE_OPERATION_MAXLENGTH.capsuleButtonMaxlength}
      edit={isEditOrCreate}
      errEditStateForm={!isEditOrCreate}
      className={!isEditOrCreate ? 'view-capsule-btn' : 'edit-capsule-btn'}
    />
  </span>
    );
